












































































































import { Component, Vue, Watch, Mixins } from "vue-property-decorator";
import NavRiwayat from "@/components/NavRiwayat.vue";
// import CardDataPasien from "@/components/pemeriksaan/CardDataPasien.vue";
import PasienFlyingBar from "@/components/PasienFlyingBar.vue";
import { RANAP_FORM_INDEX, FormIndexEntry } from "@/utils/ranapFormRegistry";
import { storeSoap } from "@/store/modules/soap";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeResume } from "@/store/modules/resume";
import { storeDokter } from "@/store/modules/dokter";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import RekamMedisRanap from "@/pages/RekamMedisRanap.vue";
import SuketRanap from "@/pages/SuketRanap.vue";
import TabResepObatRanap from "@/components/pemeriksaan/TabResepObatRanap.vue";
import TabKonsulRanap from "@/components/pemeriksaan/TabKonsulRanap.vue";
import CardOrderPenunjang from "@/components/pemeriksaan/penunjang/CardOrderPenunjang.vue";
import CardSuratRujukanRanap from "@/components/pemeriksaan/konsulRujukan/CardSuratRujukanRanap.vue";
import CardSuketV2 from "@/components/pemeriksaan/resumeSuketV2/CardSuket.vue";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import TindakanMedikPoliklinik from "@/components/pemeriksaan/pelayanan/TindakanMedikPoliklinik.vue";
import Billing from "@/services/Billing";
import LockingRegister from "@/utility/LockingRegister";
import AskepRanap from "@/components/pemeriksaan/pelayanan/AskepRanap.vue";
import DataPasien from "@/services/DataPasien";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";
import EncounterIndexStore from "@/store/modules/EncounterIndex";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import CardGeneralConsent from "@/components/pemeriksaan/tabs/persetujuan/CardGeneralConsent.vue";
import TabPersetujuanRanap from "@/components/pemeriksaan/tabs/persetujuan/TabPersetujuanRanap.vue";
import PemeriksaanReadonlyBanner from "@/components/pemeriksaan/PemeriksaanReadonlyBanner.vue";
import ActingUnitPage from "@/mixins/ActingUnitPage";
import {
  evaluatePemeriksaanReadOnly,
  evaluateVerifikasiLock
} from "@/utility/PemeriksaanReadonly";
import type { ActiveApproval } from "@/utility/PemeriksaanReadonly";
import revisionAccessModule from "@/store/modules/RevisionAccessStore";
import VerifikasiTerpaduDialog from "@/components/verifikasi/VerifikasiTerpaduDialog.vue";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";

import { resetStorePasienRanap } from "@/utils/resetStorePasien";
import { isUnitAdministrasi } from "@/utils/unit";

const ADMINISTRASI_TOP_TABS: ReadonlyArray<string> = [
  "tab-persetujuan",
  "tab-suket",
  "tab-billing"
];

@Component({
  components: {
    VerifikasiTerpaduDialog,
    NavRiwayat,
    ModalKonfirmasi,
    PasienFlyingBar,
    RekamMedisRanap,
    TabResepObatRanap,
    CardOrderPenunjang,
    CardSuratRujukanRanap,
    CardSuketV2,
    SuketRanap,
    TindakanMedikPoliklinik,
    AskepRanap,
    TabKonsulRanap,
    CardGeneralConsent,
    TabPersetujuanRanap,
    PemeriksaanReadonlyBanner
  },
  provide() {
    const self = this as {
      isReadOnly?: boolean;
      isReadOnlyDokumenPulang?: boolean;
      isVerifikasiTerkunci?: boolean;
    };
    return {
      isReadOnly: () => !!self.isReadOnly,
      isReadOnlyDokumenPulang: () => !!self.isReadOnlyDokumenPulang,
      isVerifikasiTerkunci: () => !!self.isVerifikasiTerkunci
    };
  },
  beforeCreate() {
    userModule.syncActingUnit(this.$route);

    const reg = RegisterKunjungan.getRegister(this.$route.params.register);

    reg.catch(err => {
      if (err.response?.status === 404) {
        this.$router.push("/404");
      }
    });

    reg.then(resp => {
      const dt = resp.data,
        rReg = this.$route.params.register,
        rRm = this.$route.params.rm;

      if (dt.no != rReg || dt.cm.slice(-6) != rRm) {
        this.$router.push("/404");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (AsesmenAwalRanapMedisStore.isAnyUnsavedChange) {
      const confirmAnyUnsavedAsesmen = confirm(
        "Masih ada perubahan Asesmen Awal Medis yang belum tersimpan, apakah Anda akan keluar? jika Anda keluar dari halaman pemeriksaan ini maka perubahan di Asesmen Awal Medis akan hilang."
      );

      if (!confirmAnyUnsavedAsesmen) {
        return false;
      }
    }

    LockingRegister.unlockRegister("bangsal");
    resetStorePasienRanap();

    next();
  },
  async beforeRouteUpdate(to, from, next) {
    if (AsesmenAwalRanapMedisStore.isAnyUnsavedChange) {
      const lanjut = confirm(
        "Masih ada perubahan Asesmen Awal Medis yang belum tersimpan, apakah Anda akan pindah pasien? jika Anda pindah maka perubahan di Asesmen Awal Medis akan hilang."
      );

      if (!lanjut) {
        return next(false);
      }
    }

    resetStorePasienRanap();

    try {
      await RegisterKunjungan.getRegister(to.params.register);
    } catch (err) {
      const e = err as { response?: { status?: number } };
      if (e?.response?.status === 404) {
        return next("/404");
      }
    }

    const self = this as Vue & {
      register: string;
      rm: string;
      tgl: string;
      callDataStore: () => Promise<void>;
    };
    self.register = to.params.register;
    self.rm = to.params.rm;
    self.tgl = to.params.tgl;

    await SoapRanapStore.getByRegister(self.register);
    await self.callDataStore();

    next();
  }
})
export default class PemeriksaanRanap extends Mixins(ActingUnitPage) {
  tab = "tab-rekam-medis";
  register = "";
  rm: string;
  tgl = "";
  openDrawer = false;
  msgConfirm = "";
  modalOpenKonfirmasi = false;
  statusLock = "0";
  statusCmAskep = "1";
  pasien = null;
  statusSaveAskep = true;
  isAsesmenMedisExist = null;

  // Universal form-search wiring: PasienFlyingBar -> here -> sub-page deep link.
  deepLink: any = null;

  get isUnitAdministrasi(): boolean {
    return isUnitAdministrasi(userModule.loginUnitId);
  }

  get formIndex(): FormIndexEntry[] {
    return this.isUnitAdministrasi
      ? RANAP_FORM_INDEX.filter(e => ADMINISTRASI_TOP_TABS.includes(e.topTab))
      : RANAP_FORM_INDEX;
  }

  get topTabAwal(): string {
    return this.isUnitAdministrasi ? "tab-persetujuan" : "tab-rekam-medis";
  }

  // Selecting a form in the flying-bar search: switch to the host top tab and
  // push a deep-link payload the target sub-page watches. Nonce lets the same
  // form be re-opened; sub-pages guard on payload.topTab.
  onOpenForm(payload: FormIndexEntry) {
    this.deepLink = { ...payload, nonce: Date.now() };
    this.tab = payload.topTab;
  }

  applyQueryDeepLink() {
    const q: any = this.$route.query;
    if (!q || !q.topTab) return;
    this.tab = String(q.topTab);
    this.deepLink = {
      topTab: String(q.topTab),
      elemId: q.tab ? String(q.tab) : undefined,
      category: q.category ? String(q.category) : undefined,
      nonce: Date.now(),
    };
  }

  notifToastTimeout = 10 * 1000;
  showNotifToast = false;
  notifToastMsg = "";

  get tabs() {
    const daftar = [
      {
        name: "Persetujuan",
        route: "#tab-persetujuan",
        tabId: "tab-persetujuan",
        component: "TabPersetujuanRanap",
        disabled: false,
        props: {
          register: this.register,
          rm: this.rm
        }
      },
      {
        name: "Rekam Medis",
        route: "#tab-rekam-medis",
        tabId: "tab-rekam-medis",
        component: "RekamMedisRanap",
        disabled: false,
        props: {
          register: this.register,
          rm: this.rm,
          pasien: this.pasien,
          isAsesmenMedisExist: this.isAsesmenMedisExist
        }
      },
      {
        name: "Resep Obat Ranap",
        route: "#tab-resep",
        tabId: "tab-resep",
        component: "TabResepObatRanap",
        disabled: false,
        props: null
      },
      {
        name: "Penunjang",
        route: "#tab-penunjang",
        tabId: "tab-penunjang",
        component: "CardOrderPenunjang",
        disabled: false,
        props: {
          showHasilUsgRanap: true,
          showMonitoringShortcut: true
        }
      },
      {
        name: "Rujukan",
        route: "#tab-rujukan",
        tabId: "tab-rujukan",
        component: "CardSuratRujukanRanap",
        disabled: false,
        props: null
      },
      {
        name: "Konsul",
        route: "#tab-konsul",
        tabId: "tab-konsul",
        component: "TabKonsulRanap",
        disabled: false,
        props: null
      },
      {
        name: "Surat Keterangan",
        route: "#tab-suket",
        tabId: "tab-suket",
        component: "SuketRanap",
        disabled: false,
        props: null
      },
      {
        name: "Input Billing Pelayanan",
        route: "#tab-billing",
        tabId: "tab-billing",
        component: "TindakanMedikPoliklinik",
        disabled: this.isDokter && this.stateuser.profesi !== "Psikolog",
        props: {
          statusLock: this.statusLock
          // dtResume: this.stateResume,
        }
      },
      {
        name: "Billing Askep",
        route: "#tab-billing-askep",
        tabId: "tab-billing-askep",
        component: "AskepRanap",
        disabled: this.isDokter,
        props: {
          pasien: this.pasien,
          status: this.statusCmAskep,
          disSimpan: this.statusSaveAskep
        }
      }
    ];

    return this.isUnitAdministrasi
      ? daftar.filter(t => ADMINISTRASI_TOP_TABS.includes(t.tabId))
      : daftar;
  }

  get isSp() {
    return this.stateuser.cdoc?.idsp == "1";
  }

  get isDpjp() {
    return this.registerKunjungan?.dokter?.id == this.stateuser.id;
  }

  get activeApproval(): ActiveApproval | null {
    const reg = RegisterKunjungan.register;
    const no = reg?.no;
    if (!no) return null;
    const snap = revisionAccessModule.activeByRegister[no];
    if (!snap?.has_active || !snap.active) return null;
    return {
      expiresAt: snap.active.expires_at,
      approvedAt: snap.active.approved_at,
      grantedMinutes: snap.active.granted_minutes
    };
  }

  get readOnlyResult() {
    return evaluatePemeriksaanReadOnly(
      RegisterKunjungan.register,
      new Date(),
      this.activeApproval,
      userModule.unitGate
    );
  }

  get readOnlyDokumenPulangResult() {
    return evaluatePemeriksaanReadOnly(
      RegisterKunjungan.register,
      new Date(),
      this.activeApproval,
      userModule.unitGate,
      { dokumenPulang: true }
    );
  }

  get tabTreeKey(): string {
    return `${this.register}:${userModule.segmentUnitId || ""}`;
  }

  get isReadOnly() {
    return this.readOnlyResult.readOnly;
  }

  get isReadOnlyDokumenPulang() {
    return this.readOnlyDokumenPulangResult.readOnly;
  }

  get verifikasiLockResult() {
    return evaluateVerifikasiLock(
      RegisterKunjungan.register,
      new Date(),
      this.activeApproval
    );
  }

  get isVerifikasiTerkunci() {
    return this.verifikasiLockResult.locked;
  }

  @Watch("registerKunjungan", { immediate: true, deep: false })
  onRegisterChangeFetchApproval(reg: any) {
    if (!reg?.no) return;
    const hasDischarge = !!reg.discharge_at;
    const hasDout = !!reg.dout && reg.dout !== "0000-00-00";
    if (hasDischarge || hasDout) {
      revisionAccessModule.fetchActive(reg.no);
    }
  }

  async created() {
    this.register = this.$route.params.register;
    this.rm = this.$route.params.rm;
    this.tgl = this.$route.params.tgl;

    if (this.$route.params.page) {
      this.tab = this.$route.params.page;
    }

    this.applyQueryDeepLink();

    if (this.isUnitAdministrasi && !ADMINISTRASI_TOP_TABS.includes(this.tab)) {
      this.tab = this.topTabAwal;
    }

    // if (this.$route.params.page == "tab-billing") {
    //   this.tab = "tab-billing";
    // }

    // if (this.$route.params.page == "tab-konsul") {
    //   this.tab = "tab-konsul";
    // }

    await SoapRanapStore.getByRegister(this.register);

    await this.callDataStore();
  }

  mounted() {
    //
  }

  async callDataStore() {
    // storeSoap.act_soap_on_reg(this.register);
    if (!storeDokter.list.length || !storeDokter.listAll.length) {
      await storeDokter.act_dokter_all();
    }

    if (!AsesmenAwalRanapMedisStore.asesmen) {
      AsesmenAwalRanapMedisStore.getByRegister(this.register).then(() => {
        if (this.isDpjp && this.isSp) {
          if (AsesmenAwalRanapMedisStore.asesmen) {
            this.isAsesmenMedisExist = true;
          } else {
            this.isAsesmenMedisExist = false;
            this.notifToastMsg =
              "Mohon isi asesmen awal medis terlebih dahulu!";
            this.showNotifToast = true;
          }
        }
      });
    }

    await storePasien.act_pasien_last_reg(this.rm);

    if (!storeReferensiUnit.unit.length) storeReferensiUnit.getUnit();

    if (!EncounterIndexStore.encRanap)
      EncounterIndexStore.getEncounterRanap(this.register);

    if (!storeRefAsesmen.fallriskMFS.length) {
      storeRefAsesmen.getFallriskMFS();
    }

    if (!storeRefAsesmen.fallriskHumDum.length) {
      storeRefAsesmen.getFallriskHumDum();
    }

    if (!storeRefAsesmen.nyeriNIPS.length) {
      storeRefAsesmen.getNyeriNIPS();
    }

    if (!storeRefAsesmen.nyeriFLACC.length) {
      storeRefAsesmen.getNyeriFLACC();
    }

    if (!storeRefAsesmen.nyeriBPS.length) {
      storeRefAsesmen.getNyeriBPS();
    }
  }

  stateSoap() {
    storeSoap.act_soap_on_reg(this.register);
  }

  get stateuser() {
    return userModule.user;
  }

  get statesoapdata() {
    return storeSoap.soap;
  }

  get stateResume() {
    return storeResume.resume;
  }

  get statepasien() {
    return storePasien.identitasPasien;
  }

  get showLoading() {
    return appModule.loading;
  }

  get screen() {
    if (this.$vuetify.breakpoint.lgAndDown) return "non";
    else return "default";
  }

  get isDokter() {
    return this.stateuser.isMedis;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  showTab(item) {
    this.tab = item;
  }

  openRightDrawer(v) {
    this.openDrawer = v;
  }

  lockRegister() {
    const dt = Billing.lockRegister(
      this.register,
      this.stateuser.id,
      userModule.loginUnitId,
      "bangsal"
    );
    dt.then(dt => {
      // console.log("lock ", dt);
      if (dt.status != 1) {
        this.statusLock = "0";
        appModule.sendErrorAlert(dt.message);
        this.tab = this.topTabAwal;
      } else {
        this.statusLock = "1";
      }
    });
  }
  unlockRegister() {
    const dt = Billing.unlockRegister(
      this.register,
      this.stateuser.id,
      "bangsal"
    );
    dt.then(dt => {
      this.statusLock = "0";
      // console.log("unlock ", dt, this.statusLock);
      if (dt.status != 1) {
        // appModule.sendErrorAlert(dt.message);
      }
    });
  }

  @Watch("tab")
  changeTab(val) {
    if (this.isUnitAdministrasi && !ADMINISTRASI_TOP_TABS.includes(val)) {
      this.tab = this.topTabAwal;
      return;
    }

    this.$nextTick(() => scrollTabIntoView(this.$el));
    // console.log("tab,", val);
    if (val == "tab-billing") {
      this.lockRegister();
      this.statusCmAskep = "1";
    } else if (val == "tab-billing-askep") {
      const dt = DataPasien.getDataPasienLastReg(this.rm);
      dt.then(dt => {
        if (dt["status"] != 1) {
          appModule.sendErrorAlert(dt["message"]);
        } else {
          this.lockRegister();
          this.statusCmAskep = "0";
          this.pasien = dt.data[0];
          this.statusSaveAskep = false;
        }
      });
    } else {
      this.unlockRegister();
      this.statusCmAskep = "1";
    }
  }
}
